<div class="collapsable-container">
    <div class="collapsable-container-header" (click)="collapsed = !collapsed">
      <div class="heading">
          <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
          <span class="fa fa-filter"></span> Filter: {{ FilterDescription }}
      </div>
    </div>
    <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
    <div class="row mt-3 ml-1">
        <div class="col-12">
        <form [formGroup]="filterFormGroup" class="">
            <div class="row">
                <div class="col-lg-2">
                    <!-- Filter -->
                    <div class="form-group row">
                        <div class="col-lg-12">
                            <input
                            style="width: 20px;"
                            type="checkbox"
                            name="chkZaposlen"
                            formControlName="Zaposlen"
                            >
                            <label class="form-check-label">
                                <span translate="OSOBARADNAOPREMA.OSOBA.SINGULAR" style="color: #777; opacity: 0.5"></span>
                              </label>
                        </div>
                    </div>
                </div>

 
                <div class="col-lg-2">
                    <button 
                        type="button" 
                        (click)="ApplyFilter()" 
                        class="btn btn-secondary"
                        ngbTooltip="{{'FILTER.APPLYFILTER.TOOLTIP' | translate }}">
                        <span class="fa fa-search"></span>
                    </button>
                </div>
            </div>
        </form>
        </div>
    </div>
</div>
